import { ItemType } from './types';

export const COMING_SOON_TYPES: ReadonlySet<ItemType> = new Set([
  'model',
  'mcp-server',
  'playbook',
]);

export function isComingSoonType(type: ItemType): boolean {
  return COMING_SOON_TYPES.has(type);
}

/** Windsurf only supports file-based artifacts that land in the workspace. */
export const WINDSURF_SUPPORTED_TYPES: ReadonlySet<ItemType> = new Set([
  'agent',
  'prompt',
  'skill',
  'rule',
  'template',
]);

export function isWindsurfSupportedType(type: ItemType): boolean {
  return WINDSURF_SUPPORTED_TYPES.has(type);
}

export type IconName =
  | 'smart_toy'
  | 'bolt'
  | 'chat_bubble'
  | 'gavel'
  | 'widgets'
  | 'psychology'
  | 'power'
  | 'menu_book';

export interface TypeMeta {
  label: string;
  iconName: IconName;
  color: string;
  btnColor: string;
  gradient: string;
  comingSoon?: boolean;
}

/** Per-type hero background gradients used on the detail view banner.
 *  Extracted here to avoid a circular import between ItemDetailView and CommentsSection. */
export const HERO_GRADIENT: Record<ItemType, string> = {
  agent: 'linear-gradient(160deg, #0D3E86 0%, #0057BF 50%, #007AFF 100%)',
  skill: 'linear-gradient(160deg, #0D7F46 0%, #09A761 50%, #00CE7C 100%)',
  prompt: 'linear-gradient(160deg, #993300 0%, #D64C00 50%, #F9B569 100%)',
  rule: 'linear-gradient(160deg, #0D3E86 0%, #0057BF 50%, #85CBFF 100%)',
  template: 'linear-gradient(160deg, #0D7F46 0%, #09A761 50%, #00CE7C 100%)',
  model: 'linear-gradient(160deg, #993300 0%, #D64C00 50%, #FA6E1E 100%)',
  'mcp-server':
    'linear-gradient(160deg, #0D3E86 0%, #0057BF 50%, #007AFF 100%)',
  playbook: 'linear-gradient(160deg, #0D7F46 0%, #09A761 50%, #00CE7C 100%)',
};

export const TYPE_META: Record<ItemType, TypeMeta> = {
  agent: {
    label: 'Agent',
    iconName: 'smart_toy',
    color: '#007AFF',
    btnColor: '#007AFF',
    gradient: 'linear-gradient(135deg, #0057BF, #007AFF)',
  },
  skill: {
    label: 'Skill',
    iconName: 'bolt',
    color: '#00CE7C',
    btnColor: '#09A761',
    gradient: 'linear-gradient(135deg, #09A761, #00CE7C)',
  },
  prompt: {
    label: 'Prompt',
    iconName: 'chat_bubble',
    color: '#F9B569',
    btnColor: '#D68A30',
    gradient: 'linear-gradient(135deg, #D64C00, #F9B569)',
  },
  rule: {
    label: 'Rule',
    iconName: 'gavel',
    color: '#85CBFF',
    btnColor: '#0057BF',
    gradient: 'linear-gradient(135deg, #0057BF, #85CBFF)',
  },
  template: {
    label: 'Template',
    iconName: 'widgets',
    color: '#0D7F46',
    btnColor: '#0D7F46',
    gradient: 'linear-gradient(135deg, #0D7F46, #00CE7C)',
  },
  model: {
    label: 'Model',
    iconName: 'psychology',
    color: '#D64C00',
    btnColor: '#D64C00',
    gradient: 'linear-gradient(135deg, #993300, #D64C00)',
    comingSoon: isComingSoonType('model'),
  },
  'mcp-server': {
    label: 'MCP Server',
    iconName: 'power',
    color: '#0D3E86',
    btnColor: '#0D3E86',
    gradient: 'linear-gradient(135deg, #0D3E86, #007AFF)',
    comingSoon: isComingSoonType('mcp-server'),
  },
  playbook: {
    label: 'Playbook',
    iconName: 'menu_book',
    color: '#09A761',
    btnColor: '#09A761',
    gradient: 'linear-gradient(135deg, #0D7F46, #09A761)',
    comingSoon: isComingSoonType('playbook'),
  },
};
